import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Switch from '@material-ui/core/Switch';

import './VoiceComponent.css';

const GreenCheckbox = withStyles({
  root: {
    color: 'rgb(50, 50, 50)',
    '&$checked': {
      color: 'rgb(88, 195, 194)',
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />);

const GreenSwitch = withStyles({
  switchBase: {
    color: 'rgb(88, 195, 194)',
    '&$checked': {
      color: 'rgb(88, 195, 194)',
    },
    '&$checked + $track': {
      backgroundColor: 'rgb(88, 195, 194)',
    },
  },
  checked: {},
  track: {},
})(Switch);

const decode = (cb, source) => {
  let converted = null;
  switch (cb) {
    case 'FFF':
      converted = source + '_S';
      break;
    case 'TFF':
      converted = source + '_R';
      break;
    case 'FTF':
      converted = source + '_F';
      break;
    case 'FFT':
      converted = source + '_U';
      break;
    case 'TTF':
      converted = source + '_RF';
      break;
    case 'TFT':
      converted = source + '_RU';
      break;
    case 'FTT':
      converted = source + '_FU';
      break;
    case 'TTT':
      converted = source + '_RFU';
      break;
  }
  return converted;
}

function VoiceComponent(props) {
  const {root, reverse, uttr_id, bkg_id, lb_bkg_id} = props;
  const [state, setState] = React.useState({
    checkedRhythm: false,
    checkedPitch: false,
    checkedTimbre: false,
    source: `${root}`,
    target: `${reverse}`,
    converted: `${root}_S`,
    isReversed: false,
  });
  const audio = React.useRef();
  const audio1 = React.useRef();
  const audio2 = React.useRef();

  const handleChange = name => event => {


    const s = state;
    state[name] = event.target.checked;
    const source = !state.isReversed ? props.root : props.reverse;
    const cb = ''  + (s.checkedRhythm ? 'T' : 'F') + (s.checkedPitch ? 'T' : 'F') + (s.checkedTimbre ? 'T' : 'F');

    setState({ ...state, [name]: event.target.checked, converted: decode(cb, source) });
    audio.current.load();
  };
  const handleSwitch = name => event => {


    const s = state;
    const source = !event.target.checked ? props.root : props.reverse;
    const target = !event.target.checked ? props.reverse : props.root;
    const cb = ''  + (s.checkedRhythm ? 'T' : 'F') + (s.checkedPitch ? 'T' : 'F') + (s.checkedTimbre ? 'T' : 'F');

    setState({ ...state, isReversed: event.target.checked, converted: decode(cb, source), source, target });
    audio1.current.load();
    audio2.current.load();
    audio.current.load();
  };
  return (
    <div style={{ width: 1000 }}>
      <p className={lb_bkg_id}>{uttr_id}</p>
      <div className={bkg_id}>
      <p className="speech-label">Source Speech</p>
      <div className="voice-block">
        <div className="voice-block-img">
          <img src={`spect/${state.source}_S.png`}/>
        </div>
        <div className="voice-block-wav">
        <audio controls ref={audio1}>
          <source src={`audio/${state.source}_S.wav`} type="audio/wav" />

          Your browser does not support the audio element.
        </audio>
        </div>
      </div>

      <p className="speech-label">Target Speech</p>
      <div className="voice-block">
        <div className="voice-block-img">
          <img src={`spect/${state.target}_S.png`}/>
        </div>
        <div className="voice-block-wav">
        <audio controls ref={audio2}>
          <source src={`audio/${state.target}_S.wav`}  type="audio/wav" />

          Your browser does not support the audio element.
        </audio>
        </div>
      </div>

      <p className="speech-label">Choose What To Convert:</p>

      <FormGroup style={{ padding: '0 30px' }} row>
      <FormControlLabel
          control={
            <GreenCheckbox
              checked={state.checkedRhythm}
              onChange={handleChange('checkedRhythm')}
              value="checkedRhythm"
            />
          }
          label="Rhythm"
        />
        <FormControlLabel
          control={
            <GreenCheckbox
              checked={state.checkedPitch}
              onChange={handleChange('checkedPitch')}
              value="checkedPitch"
            />
          }
          label="Pitch"
        />
        <FormControlLabel
          control={
            <GreenCheckbox
              checked={state.checkedTimbre}
              onChange={handleChange('checkedTimbre')}
              value="checkedTimbre"
            />
          }
          label="Timbre"
        />
        <FormControlLabel
        control={
          <GreenSwitch
            checked={state.isReversed}
            onChange={handleSwitch(null)}
            value="checkedB"
          />
        }
        label="Flip source and target"
      />
      </FormGroup>
      <p className="speech-label">Converted Speech</p>
      <div className="voice-block">
        <div className="voice-block-img">
          <img src={`spect/${state.converted}.png`}/>
        </div>
        <div className="voice-block-wav">
        <audio controls ref={audio}>
          <source src={`audio/${state.converted}.wav`}  type="audio/wav" />

          Your browser does not support the audio element.
        </audio>
        </div>
      </div>

    </div>
    </div>
    
  );
}

export default VoiceComponent;
